<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import Button from '@uiKit/elements/Button.vue'
import PiIcon, { type PiIconName } from '@uiKit/elements/PiIcon.vue'
import InvestPropertyStrip from './InvestPropertyStrip.vue'

export interface EligibilityFix {
  icon: PiIconName
  title: string
  description: string
  ctaLabel: string
}

interface Props {
  fix: EligibilityFix
  propertyImage: string
  propertyTitle: string
  propertyLocation: string
}

defineProps<Props>()

defineEmits<{
  (e: 'cta'): void
}>()
</script>

<template>
  <Box direction="col" gap="4" class="invest-blocker__body">
    <InvestPropertyStrip
      :image="propertyImage"
      :title="propertyTitle"
      :location="propertyLocation"
    />
    <Box direction="col" gap="3" align="center" class="invest-blocker__content">
      <Box align="center" justify="center" class="invest-blocker__icon">
        <PiIcon :name="fix.icon" />
      </Box>
      <Text type="page-title" align="center">{{ fix.title }}</Text>
      <Text type="body" color="muted" align="center">{{ fix.description }}</Text>
    </Box>
  </Box>
  <Box class="invest-blocker__footer">
    <Button
      :label="fix.ctaLabel"
      icon="arrow-right"
      icon-pos="right"
      size="large"
      block
      @click="$emit('cta')"
    />
  </Box>
</template>

<style scoped>
.invest-blocker__body {
  flex: 1;
  padding: 1.25rem 1.5rem 1rem;
}

.invest-blocker__content {
  padding: 24px 16px;
}

.invest-blocker__icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--p-primary-100);
  color: var(--p-primary-500);
  font-size: 22px;
}

.invest-blocker__footer {
  position: sticky;
  bottom: 0;
  padding: 0.75rem 1.5rem 1rem;
  background: var(--p-surface-0);
  border-top: 1px solid var(--p-content-border-color);
  box-shadow: 0 -8px 16px -16px rgba(0, 0, 0, 0.1);
}
</style>
